import Preview from './Preview.vue';

export default Preview;
